<template>
    <b-modal
        size="xl"
        v-model="modalShow"
        title="マッチング内容の確認"
        @ok="handleOk"
        ok-title="決定"
        ok-variant="yokumiru-orange"
        :ok-disabled="inProgress"
        cancel-title="キャンセル"
        cancel-variant="yokumiru-gray"
        :cancel-disabled="inProgress"
        @hidden="close">
        <div class="t-admin">
            <div v-if="consultation !== null && doctor !== null">
                <div class="detailWrapper">
                    <div class="title">{{ `マッチングする${$locale.consultation_host}予約` }}</div>
                    <ul class="detailList">
                        <li>
                            <div>{{ `${$locale.consultation_host}日時:` }}</div>
                            <div class="d-flex">
                                <div class="u-palt">
                                    <span>{{ helper.dateForHuman(consultation.start_time, timezone) }}</span><!--
                                 --><span :class="helper.dayForHumanCSS(consultation.start_time ,timezone)">
                                        {{ helper.dayForHuman(consultation.start_time, timezone, { bracket: true } ) }}
                                    </span>
                                </div>
                                <div class="u-palt ml-1">
                                    <span>{{ helper.timeForHuman(consultation.start_time, timezone) }}</span><!--
                                 --><span>〜</span><!--
                                 --><span>{{ helper.timeForHuman(consultation.end_time, timezone) }}</span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div>{{ `${$locale.consultation_host}科:` }}</div>
                            <div>{{ consultation.medical_course.name }}</div>
                        </li>
                    </ul>
                </div>
                <div class="detailWrapper">
                    <div class="title">{{ `${$locale.patient}情報` }}</div>
                    <ul class="detailList detailListUser">
                        <li>
                            <div>名前:</div>
                            <div>
                                <span>{{ consultation.user.full_name }}</span>
                                <span class="text-muted small">{{ `(${consultation.user.full_name_kana})` }}</span>
                            </div>
                        </li>
                        <li>
                            <div>年齢:</div>
                            <div>{{ `${consultation.user.age}歳` }}</div>
                        </li>
                        <li>
                            <div>性別:</div>
                            <div>{{ `${consultation.user.sex ? '女性' : '男性'}` }}</div>
                        </li>
                        <li>
                            <div>タイムゾーン:</div>
                            <div>{{ `${helper.getOffsetFromUTC(consultation.user.timezone)} ${consultation.user.timezone}` }}</div>
                        </li>
                    </ul>
                </div>
                <div class="detailWrapper">
                    <div class="title">マッチングする医師</div>
                    <ul class="detailList detailListUser">
                        <li>
                            <div>名前:</div>
                            <div>
                                <span>{{ doctor.full_name }}</span>
                                <span class="text-muted small">{{ `(${doctor.full_name_kana})` }}</span>
                            </div>
                        </li>
                        <li>
                            <div>{{ `${$locale.consultation_host}科` }}:</div>
                            <div>{{ medicalCoursesFormat(doctor.medical_courses) }}</div>
                        </li>
                        <li>
                            <div>タイムゾーン:</div>
                            <div>{{ `${helper.getOffsetFromUTC(doctor.timezone)} ${doctor.timezone}` }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import YokumiruHelper from '../../../YokumiruHelper'
import constants from '../../../constants'

export default {
    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            consultation: null,
            doctor: null,
            timezone: 'Asia/Tokyo',
            errors: {},
        }
    },

    created: function () {
        bus.$on('open-modal-admin-matching-doctor-confirm', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-matching-doctor-confirm')
    },

    methods: {
        /**
         * モーダル表示
         * @param {object} consultation
         * @param {object} doctor
         */
        open: function (consultation, doctor) {
            this.consultation = { ...consultation }
            this.doctor = { ...doctor }
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * 所属相談科の表示
         * @param {object} courses
         */
        medicalCoursesFormat: function (courses) {
            let result = ''
            courses.forEach((course) => result += `${course.name}、`)
            return result.length > 0 ? result.slice(0, -1) : result
        },

        /**
         * 決定ボタン押下時
         * @param {object} e
         */
        handleOk: async function (e) {
            e.preventDefault()

            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.consultations.endpoint.base

            await axios.post(`${endpoint}/${this.consultation.id}/matching_doctors/${this.doctor.id}`)
                .then(() => {
                    bus.$emit('alert-success', `${this.$locale.consultation_host}医師のマッチングが完了しました。`)
                    bus.$emit('admin-doctor-matching-completed')
                    this.errors = {}
                    this.close()
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        this.errors = response.data.errors
                        bus.$emit('alert-danger')
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.detailWrapper {
    margin: 10px;
    padding: 15px 20px;
    background: #F3F3F3;
    border-radius: 8px;
    box-sizing: border-box;

    .title {
        font-size: 18px;
        font-weight: bold;
    }

    .detailList {
        padding-left: 0;
        margin: 7px 0 0;

        li {
            display: flex;
        }

        div {
            &:nth-child(1) {
                min-width: 76px;
            }
        }

        a {
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }
    }

    .detailListUser {
        div {
            &:nth-child(1) {
                min-width: 100px;
            }
        }
    }
}
</style>
